module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/readable-stream/duplex-browser.js
// module id = 1706
// module chunks = 1